import React from 'react';
import { connect } from 'react-redux'
import Clipboard from 'react-clipboard.js';
import {
  feeds_index,
  archive_feed,
  publish_all,
  unpublish_all,
  reset_feed_errors
 } from '../actions'
import { Link, Redirect } from 'react-router-dom'
import Pagination from './Pagination'
import Loading from './Loading';
import {
  is_logged_on,
  is_validating
 } from "../helpers"

const mapStateToProps = state => {
  return {
    feed: state.feed
  };
};

const mapDispatchToProps = dispatch => {
    return {
      getFeeds: (page) => dispatch ( feeds_index(page) ),
      archiveFeed: (feed_id, page) => dispatch ( archive_feed(feed_id, page) ),
      publishAll: (feed_id, page) => dispatch ( publish_all(feed_id, page) ),
      unpublishAll: (feed_id, page) => dispatch ( unpublish_all(feed_id, page) ),
      resetErrors: () => dispatch ( reset_feed_errors() )
    }
}

class ConnectedProjects extends React.Component {
  constructor () {
    super()
    this.state = {
      clickedId: ''
    }
  }

  setCurrent(id) {
    this.setState({clickedId: id})
  }

  resetCurrent() {
    this.setState({clickedId: ''})
  }

  archiveFeed(feed_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.feed.pagination
    this.props.archiveFeed(feed_id, page)
  }

  componentDidMount() {
    this.props.getFeeds(1)
  }

  componentWillUnmount() {
    this.props.resetErrors()
  }

  render() {
    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/" />
    }

    const feeds = this.props.feed.items;
    const { fetching } = this.props.feed;

    if (fetching || typeof(this.props.feed.pagination) === "undefined") {
      return (
       <Loading />
      )
    }

    const { publishAll, unpublishAll } = this.props;

    const pagination = (typeof(this.props.feed.pagination) === "undefined") ? {page: 1, per_page:10} : this.props.feed.pagination;

    const {page} = this.props.feed.pagination

    return (
      <div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Projects List</span>
					<i className="material-icons right">list</i>
				</div>
				<table className="bordered striped highlight responsive-table projects-list">
					<thead>
						<tr>
							<th>Project Name</th>
							<th>Date Created</th>
              {
                // <th>User</th>
              }
							<th>Details</th>
							<th>Status</th>
							<th>Actions</th>
						</tr>
					</thead>
				 	<tbody>
						{feeds.map(function(feed){
							const {id, name, created_at, draft, optimizations, published, archived, rows, feed_type} = feed;
              const current = this.state.clickedId

              const publishAllBtn = (
                <button className="btn light-green waves-effect waves-light mr-10" onClick={(e) => {
                    console.log(page)
                    publishAll(feed.id, page)
                  }}>Publish All</button>
              )

              const unpublishAllBtn = (
                <button className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e) => {
                    console.log(page)
                    unpublishAll(feed.id, page)
                  }}>Unpublish All</button>
              )

							let btn;
              if (optimizations > 0 && published === optimizations) {
                btn = unpublishAllBtn
              } else if (optimizations > 0 && published > 0) {
								btn =(
                  <div>
                    {publishAllBtn} {unpublishAllBtn}
                  </div>
                );
							} else if (optimizations > 0 && published === 0) {
								btn = publishAllBtn
							} else {
                // optimizations = 0
                btn = ''
              }

              let links
              if (feed.id !== current) {
                links = (
                  <div className="meta" onMouseLeave={(e) => {
                    this.resetCurrent()
                  }}>
                    <Link className="c-darkgrey" to={`/projects/${feed.id}`}>View</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.setCurrent(feed.id)
                      }}
                      > Trash</Link>
                  </div>
                )
              } else {
                links = (
                  <div className="meta">
                    <Link className="c-darkgrey" to="#" onClick={(e)=>{
                      e.preventDefault()
                      this.resetCurrent()
                    }}>Cancel</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.archiveFeed(feed.id)
                      }}
                      >Are you sure?</Link>
                  </div>
                )
              }

              let statusIcon, statusTitle
              if (optimizations > 0 && (published + archived === optimizations)) {
                statusIcon = <i className="material-icons c-light-green">cloud_done</i>
                statusTitle = "All instances are published"
              } else if (optimizations > 0 && published === 0){
                statusIcon = <i className="material-icons c-grey">cloud_upload</i>
                statusTitle = "No published instances"
              } else if (optimizations > 0) {
                statusIcon = <i className="material-icons c-yellow">cloud</i>
                statusTitle = "Some instances are published"
              } else {
                // optimizations = 0
                statusIcon = <i className="material-icons c-grey">cloud_off</i>
                statusTitle = "There are no instances"
              }


							return (
								<tr key={id}>
									<td>
										<Link className="view" to={`/projects/${feed.id}`}>{name}</Link>
                    {
                      (feed_type !== "textfile") ? (
                        <p className="feedUrl c-darkgrey">
                          <Clipboard data-clipboard-text={feed.url} className="clipboard clip-black">
                            <i className="material-icons tiny c-darkgrey">content_copy</i>
                          </Clipboard>
                          {feed.url}
                        </p>
                      ) : (
                        <p className="feedUrl c-darkgrey">
                          Uploaded from file
                        </p>
                      )
                    }
                    { links }
									</td>
									<td>{new Date(created_at).toLocaleDateString()}, {new Date(created_at).toLocaleTimeString()}</td>
                  {
                    // <td>user here</td>
                  }
									<td>
                    <small><p>{rows} Rows on original feed</p></small>
										<small><p>{optimizations} Optimized Feeds</p></small>
										<small><p>{published} Published</p></small>
										<small><p>{draft} Draft</p></small>
                    <small><p>{archived} Archived</p></small>
									</td>
									<td title={statusTitle}>
                    { statusIcon }
									</td>
									<td>
										{btn}
									</td>
								</tr>
							)
						}, this)}
			 		</tbody>
				</table>
        <Pagination pagination={pagination} fetchPage={this.props.getFeeds}/>
      </div>
    )
  }

}

const Projects = connect(mapStateToProps, mapDispatchToProps)(ConnectedProjects);

export default Projects;



// WEBPACK FOOTER //
// ./src/js/components/Projects.js